define(["marionette", "underscore", "messaging/messenger", "./kbConfigView"], function (
  Marionette,
  _,
  Messenger,
  KbConfigView,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "userAdminKbConfig";
      this.region = options.region;
      this.user = options.user;
    },
    show: function () {
      //set what kb we are configuring in the KB Configuration Area
      this.user.currentConfigKbId = Messenger.reqres.request("active:kb"); //set it at first to the currently active kb
      this._fetchKbCollections(this.user.currentConfigKbId);

      this.view = new KbConfigView.view({
        model: this.user,
      });
      this.view.on(
        "change:selected:kb",
        (kbId) => {
          this.user.currentConfigKbId = +kbId; //set kbId of the currently configured KB
          //load the parameters for the kb configuration
          this._setUpKbProperties(this.user.currentConfigKbId);
        },
        this,
      );
      this.view.on("change:kb:language", (languageId) => {
        //change the language parameter in the currentConfigKbId
        this._setKbDefaultProperty("responseLanguageId", +languageId, this.user.currentConfigKbId);
        this.user.trigger("change");
      });
      this.view.on("change:kb:touchpoint", (touchPointId) => {
        this._setKbDefaultProperty("touchPointId", +touchPointId, this.user.currentConfigKbId);
        this.user.trigger("change");
      });
      this.view.on("change:kb:context", (contextId) => {
        this._setKbDefaultProperty("contextId", +contextId, this.user.currentConfigKbId);
        this.user.trigger("change");
      });

      // NOTE: These collections do not seem to work quite right with the existing logic to show a loading view,
      // so they have to be handled using onSynced() instead.
      this.user.kbTouchPoints.onSynced(() => {
        this.user.kbContexts.onSynced(() => {
          this.user.kbLanguages.onSynced(() => {
            this.showRegion(this.view);
          });
        });
      });
    },
    _fetchKbCollections: function (kbId) {
      //set the kb specific lists for the active kb (touchPoints, languages, contexts)
      this.user.kbTouchPoints = Messenger.reqres.request("fetch:kb:touchpoints", kbId);
      this.user.kbContexts = Messenger.reqres.request("fetch:kb:contexts", kbId);
      this.user.kbLanguages = Messenger.reqres.request("fetch:kb:languages", kbId);
    },
    _setKbDefaultProperty: function (propertyName, value, kbId) {
      kbId = parseInt(kbId, 10);
      const kbDefaults = _.findWhere(this.user.get("kbDefaults"), { id: kbId });
      kbDefaults.value[propertyName] = value;
    },
    _setUpKbProperties: function (kbId) {
      this._fetchKbCollections(kbId);
      this.user.kbTouchPoints.once("sync", () => this.view.render());
      this.user.kbContexts.once("sync", () => this.view.render());
      this.user.kbLanguages.once("sync", () => this.view.render());
    },
  });
});
